export default __webpack_public_path__ + "static/media/IMG_0265.a8d090ed.jpeg";